import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { WarehouseCollectionModel } from "@tFissco/ApiModels";

import { getWarehouses, GetWarehousesApiParameterExtended } from "@tFissco/Services/CustomWarehouseService";

export interface LoadWarehousesParameter {
    onSuccess?: () => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    LoadWarehousesParameter,
    GetWarehousesApiParameterExtended,
    WarehouseCollectionModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const CustomDataFromApi: HandlerType = async props => {
    props.apiResult = await getWarehouses(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const chain = [PopulateApiParameter, CustomDataFromApi];

const loadWarehouses = createHandlerChainRunner(chain, "LoadWarehousesData");
export default loadWarehouses;
